import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'

const MainLayout = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Navbar component */}
      <Navbar />
      {/* Content area for child components */}
      {children}
      {/* Footer component */}
      <Footer />
    </div>
  )
}

export default MainLayout